import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import SalesOrderCreate from '../../components/Sales/SalesOrderCreate';

const SalesOrderCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <SalesOrderCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default SalesOrderCreatePage;